/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SecurityEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const securityEntrypoint: EntryPoint<SecurityEntrypointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<SecurityEntrypointComponent>(
		/* webpackChunkName: "async-security-entrypoint" */ './ExportedDefault.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
